<ion-header class="modal-header">
  <div class="modal-title">
    <h3>{{ id ? 'Edit Custom Field' : 'Add Custom Field' }}</h3>
  </div>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="clear" shape="round" class="close-button" (click)="dismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div style="padding: 16px">
    <h2 class="input-section-header">Configure</h2>
    <div class="input-section-divider"></div>

    <app-custom-fields
      *ngIf="field"
      [customFields]="[field]"
      [placeholder]="'Ex: Favorite color'"
      [addCustomFieldButtonLabel]="'Add a custom ticket field'"
      [showDescription]="true"
      [hideAddAndDeleteButtons]="true"
      [showRequiredOption]="false"
      [editMode]="!!id"
      [readOnly]="false"
    >
    </app-custom-fields>
  </div>

  <div style="padding: 0 16px 16px 16px" *ngIf="field?.label">
    <h2 class="input-section-header">Preview</h2>
    <div class="input-section-divider"></div>

    <div class="preview-container" style="margin-top: 16px">
      <ion-card class="outline-card">
        <app-response-input [responseInputFields]="[field]" [showPublicOption]="false" layout="list">
        </app-response-input>
      </ion-card>
    </div>
  </div>

  <div style="padding: 0 16px 10px 16px">
    <h2 class="input-section-header">AI Options</h2>
    <div class="input-section-divider"></div>
    <ion-label class="input-label">
      Prefill Value on Status Change
      <ion-icon
        name="information-circle"
        class="icon-padded-left"
        ngxTippy
        data-tippy-content="When a ticket is updated to this status, or a downstream status, the AI will attempt to prefill this value."
      ></ion-icon>
    </ion-label>
    <button
      class="select-outline input-field fake-form-select"
      (click)="showSubStatusPopover($event)"
      [disabled]="isLoading"
      expand="block"
      fill="outline"
    >
      <span>
        <ion-icon
          *ngIf="selectedSubStatusDisplay?.icon"
          [name]="selectedSubStatusDisplay?.icon"
          [class]="selectedSubStatusDisplay?.iconClass"
          slot="start"
          style="margin: 0 5px 2px 0"
        ></ion-icon>
        <ion-label *ngIf="selectedSubStatusDisplay"
          >{{ selectedSubStatusDisplay.name }} ({{ selectedSubStatusDisplay.type }})</ion-label
        >
        <ion-label *ngIf="!selectedSubStatusDisplay">None</ion-label>
      </span>
      <ion-icon name="caret-down-outline" slot="end"></ion-icon>
    </button>
  </div>

  <div style="padding: 0 16px 16px 16px">
    <ion-label class="input-label">
      Prefill Prompt
      <ion-icon
        name="information-circle"
        class="icon-padded-left"
        ngxTippy
        data-tippy-content="Enter a prompt for the AI to use when prefilling this field. This will guide the AI in generating a relevant value."
      ></ion-icon>
    </ion-label>
    <ion-textarea
      class="input-field"
      [(ngModel)]="field.prefillPrompt"
      placeholder="e.g., Summarize the issue based on the initial customer message."
      [autoGrow]="true"
      rows="3"
    ></ion-textarea>
  </div>
</ion-content>
<ion-footer class="footer flex-space-between">
  <ion-button (click)="submit()" [disabled]="isLoading">
    Save
    <ion-spinner name="crescent" [hidden]="!isLoading" style="margin-left: 10px"></ion-spinner>
  </ion-button>
  <div>
    <ion-button
      fill="clear"
      color="dark"
      (click)="duplicate()"
      [disabled]="isLoading"
      *ngIf="id"
      ngxTippy
      data-tippy-content="Duplicate"
      style="margin-left: 10px"
    >
      <ion-icon name="duplicate-outline"></ion-icon>
    </ion-button>
    <ion-button
      fill="clear"
      color="dark"
      (click)="delete()"
      [disabled]="isLoading"
      *ngIf="id"
      ngxTippy
      data-tippy-content="Delete"
    >
      <ion-icon name="trash-outline"></ion-icon>
    </ion-button>
  </div>
</ion-footer>
